import {DataFetcher} from '@aboutyou/data-fetcher';
import {ProductTilePreferences} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_tile_preferences.types';
import {useTranslation} from '@aboutyou/i18n';
import React, {FC, memo} from 'react';
import {ProductStreamSkeleton} from '../../../features/ProductStream/ProductStreamSkeleton';
import {StreamTileList} from '../../../features/ProductStream/StreamTileList';
import {TilesViewOffsetLimitProps} from '../../../features/ProductStream/TilesByPageOffsetLimit';
import {useAdditionalProductsByPage} from '../utils/useAdditionalProductsByPage';

const ErrorComponent = () => {
  const {t} = useTranslation();

  return <div>{t('Oops! Something went wrong!')}</div>;
};

const AdditionalTiles: FC<
  Omit<TilesViewOffsetLimitProps, 'request' | 'setNextToken'>
> = ({renderingPriority, ...viewProps}) => {
  return (
    <DataFetcher
      request={useAdditionalProductsByPage(viewProps.page)}
      Loading={ProductStreamSkeleton}
      Error={ErrorComponent}
      viewProps={viewProps}
      renderingPriority={renderingPriority}
      View={({preferredProductImageType, itemsPreferences, ...props}) => {
        const itemsPreferencesMerged = preferredProductImageType
          ? ({
              ...itemsPreferences,
              preferredProductImageType,
            } as ProductTilePreferences)
          : itemsPreferences;

        return (
          <StreamTileList
            {...props}
            itemsPreferences={itemsPreferencesMerged}
          />
        );
      }}
    />
  );
};

export const AdditionalTilesByPage = memo(AdditionalTiles);
